/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import { PaymentElement, useElements, useStripe, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../config/axios.config";
import { handleError } from "../utils/functions";
import { toast } from "react-toastify";

const CheckoutForm = ({ message, setMessage }) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  let [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  const handlePurchaseSuccess = async () => {
    const { data } = await axiosInstance.post("/payment/success", {
      orderId: searchParams.get("orderId"),
      clientSecret: searchParams.get("payment_intent_client_secret"),
    });
    if (data.error) {
      toast.error(data.message);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(async ({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          handlePurchaseSuccess();
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!stripe || !elements) {
        return;
      }
      setIsLoading(true);

      const res = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: `http://localhost:3000/payment?orderId=${searchParams.get("orderId")}` },
      });
      if (res?.error?.type === "card_error" || res?.error?.type === "validation_error") {
        setMessage(res.error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const paymentElementOptions = {
    layout: "auto",
  };

  return (
    <>
      <div className="bg-white rounded-lg p-4">
        <form id="payment-form" onSubmit={handleSubmit}>
          <PaymentElement id="payment-element" options={paymentElementOptions} />
          <button disabled={isLoading || !stripe || !elements} id="submit" className="btn btn-primary mt-4">
            <span id="button-text">{isLoading ? "Processing" : "Pay now"}</span>
          </button>
          {message && <div id="payment-message">{message}</div>}
        </form>
      </div>
    </>
  );
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Payment = () => {
  console.log(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

  const [clientSecret, setClientSecret] = useState("");
  const [message, setMessage] = useState("");
  let [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  useEffect(() => {
    if (searchParams.get("payment_intent_client_secret")) {
      setClientSecret(searchParams.get("payment_intent_client_secret"));
      return;
    }

    const getData = async () => {
      try {
        const { data } = await axiosInstance.post("/payment/create-intent", {
          orderId,
        });
        if (!data.error) {
          setClientSecret(data.clientSecret);
        }
      } catch (error) {
        handleError(error);
      }
    };
    getData();
  }, [searchParams, orderId]);

  const appearance = {
    theme: "light",
  };
  const options = {
    clientSecret,
    appearance,
  };
  return (
    <>
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Payment"} />

      <div className="d-flex justify-content-center">
        {/* Main Start*/}
        {clientSecret && (
          <div style={{ maxWidth: "400px" }}>
            <Elements options={options} stripe={stripePromise}>
              <CheckoutForm message={message} setMessage={setMessage} />
            </Elements>
          </div>
        )}
      </div>

      {/* Main End */}
      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default Payment;
